import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useUserContext } from "../context/UserContext";

const UserRoute: React.FC = () => {
  const { basicData, loading } = useUserContext();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-[60vh]">
        <p className="text-sm text-gray-500">Loading...</p>
      </div>
    );
  }

  const isAdmin =
    basicData?.role_name?.toUpperCase() === "ADMIN";

  if (isAdmin) {
    return <Navigate to="/admin" replace />;
  }

  return <Outlet />;
};

export default UserRoute;